import styled from 'styled-components';

export const MapWrapper = styled.div`
  width: 100%;
  height: 100%;
`;
